export const HYPERCORE_USDC_ASSET_ID =
	"1cs_v1:hypercore:erc20:0xb88339CB7199b77E23DB6E890353E22632Ba630f";
